import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import download from "../image/dowload.svg";
import Template1 from "../Component/template/Template1";
import { motion } from "framer-motion";
import formatFormData from "../utils/formatFormData";
import Template2 from "../Component/template/Template2";
import Template3 from "../Component/template/Template3";
import Template4 from "../Component/template/Template4";
import Template6 from "../Component/template/Template6";
import Template7 from "../Component/template/Template7";
import Template8 from "../Component/template/Template8";
import Template9 from "../Component/template/Template9";
import Template10 from "../Component/template/Template10";
import Template11 from "../Component/template/Template11";
import Template12 from "../Component/template/Template12";
import { API_URL } from "../apiConfig";
import TemplateRenderer from "../Component/template/TemplateRenderer";
import sampleResume1 from "../image/home/sample-resumes/sample-1.png";
import sampleResume2 from "../image/home/sample-resumes/sample-2.png";
import sampleResume3 from "../image/home/sample-resumes/sample-3.png";
import sampleResume4 from "../image/home/sample-resumes/sample-4.png";
import sampleResume5 from "../image/home/sample-resumes/sample-5.jpg";
import bgHome1 from "../image/home/background/bg-home-01.png";
import bgHome2 from "../image/home/background/bg-home-02.png";
import bgHome3 from "../image/home/background/bg-home-03.png";
import It from "../image/home/icons/IT.png";
import real_estate from "../image/icons/real_estate.png";
import sales from "../image/icons/sales.png";
import salon from "../image/icons/salon.png";
import sports from "../image/icons/sports.png";
import travel from "../image/icons/travel.png";
import quality from "../image/icons/quality.png";
import legal from "../image/icons/legal.png";
import health from "../image/icons/health.png";
import engineer from "../image/icons/engineer.png";
import education from "../image/icons/education.png";
import accounts from "../image/icons/accounts.png";
import chef from "../image/icons/chef.png";
import Navbar from "../Component/navbar.jsx";
import Footer from "../Component/footer.jsx";
import { IoIosRefresh } from "react-icons/io";
import { FaAngleLeft, FaArrowRightLong } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCube, Autoplay, Navigation } from "swiper/modules"; // Import necessary modules
import "swiper/css"; // Core Swiper styles
import "swiper/css/navigation"; // Navigation styles
import "swiper/css/pagination"; // Pagination styles (if needed)
import "swiper/css/effect-cube"; // Effect Cube styles
import { CiSearch, CiStar } from "react-icons/ci";
import aiResumeStore from "../store/aiResumes.zustand";

const Resume_exmp = () => {
  const navigate = useNavigate();
  const zustandAIResumes = aiResumeStore((state) => state.resumes);

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const points = [
    "Experience in Python - Pandas, Numpy for developing designing data-driven systems, Expertise in querying -",
    "SQL(Postgres DB is a good to have), Data modeling concepts, Data warehouse concepts, ETL, Version control - ",
    "Git Bitbucket Agile development Skills desired: Job schedulers - Autosys Airflow KDB",
  ];

  const [showAll, setShowAll] = useState(false);
  const [showAllAccounts, setShowAllAccounts] = useState(false);
  const [showAllEducation, setShowAllEducation] = useState(false);
  const [showAllHealth, setShowAllHealth] = useState(false);
  const [showAllQuality, setShowAllQuality] = useState(false);
  const [showAllSports, setShowAllSports] = useState(false);
  const [showAllEngineer, setShowAllEngineer] = useState(false);
  const [showAllSales, setShowAllSales] = useState(false);
  const [showAllEstate, setShowAllEstate] = useState(false);
  const [showAllFood, setShowAllFood] = useState(false);
  const [showAllSalon, setShowAllSalon] = useState(false);
  const [showAllTravel, setShowAllTravel] = useState(false);
  const [showAllLegal, setShowAllLegal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Filtered resumes based on search query
  const filteredResults = (zustandAIResumes ?? []).filter((el) =>
    el?.resumeTitle?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Autocomplete suggestions (first 5 matches)
  const suggestions = filteredResults.slice(0, 5);
  // Filter IT resumes
  const filteredResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "it")
  );
  const visibleResumes = showAll
    ? filteredResumes
    : filteredResumes.slice(0, 4);
  const filteredAccountResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "account")
  );
  const visibleAccountResumes = showAllAccounts
    ? filteredAccountResumes
    : filteredAccountResumes.slice(0, 4);
  const filteredEducationResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "education")
  );
  const visibleEducationResumes = showAllEducation
    ? filteredEducationResumes
    : filteredEducationResumes.slice(0, 4);
  const filteredHealthResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "medical")
  );
  const visibleHealthResumes = showAllHealth
    ? filteredHealthResumes
    : filteredHealthResumes.slice(0, 4);
  const filteredQualityResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "quality")
  );
  const visibleQualityResumes = showAllQuality
    ? filteredQualityResumes
    : filteredQualityResumes.slice(0, 4);
  const filteredSportsResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "sports")
  );
  const visibleSportsResumes = showAllSports
    ? filteredSportsResumes
    : filteredSportsResumes.slice(0, 4);
  const filteredEngineerResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "engineer")
  );
  const visibleEngineerResumes = showAllEngineer
    ? filteredEngineerResumes
    : filteredEngineerResumes.slice(0, 4);
  const filteredSalesResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "sales")
  );
  const visibleSalesResumes = showAllSales
    ? filteredSalesResumes
    : filteredSalesResumes.slice(0, 4);
  const filteredEstateResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "estate")
  );
  const visibleEstateResumes = showAllEstate
    ? filteredEstateResumes
    : filteredEstateResumes.slice(0, 4);
  const filteredFoodResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "food")
  );
  const visibleFoodResumes = showAllFood
    ? filteredFoodResumes
    : filteredFoodResumes.slice(0, 4);
  const filteredSalonResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "salon")
  );
  const visibleSalonResumes = showAllSalon
    ? filteredSalonResumes
    : filteredSalonResumes.slice(0, 4);
  const filteredTravelResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "travel")
  );
  const visibleTravelResumes = showAllTravel
    ? filteredTravelResumes
    : filteredTravelResumes.slice(0, 4);
  const filteredLegalResumes = (zustandAIResumes ?? []).filter(
    (el) =>
      Array.isArray(el?.tags) &&
      el?.tags.some((tag) => tag.toLowerCase() === "legal")
  );
  const visibleLegalResumes = showAllLegal
    ? filteredLegalResumes
    : filteredLegalResumes.slice(0, 4);
  const [visiblePoints, setVisiblePoints] = useState([]);
  const images = [bgHome1, bgHome2, bgHome3];
  const [totalResumes, setTotalResumes] = useState(0);
  const [currentBgImage, setCurrentBgImage] = useState(images[0]);
  const fetchAIResumes = async () => {
    setLoading(true); // Set loading to true while fetching
    try {
      console.log("Fetching resumes...");

      const response = await axios.get(
        `${API_URL}/api/v1/generate-summary/active-resumes`,
        {
          params: { page },
          withCredentials: true,
        }
      );

      console.log("API Response:", response); // Log entire response

      if (response?.data?.success) {
        aiResumeStore.getState().setResumes(response?.data?.data);
        setTotalResumes(response?.data?.total);
      } else {
        console.warn("API did not return success:", response?.data);
      }
    } catch (error) {
      console.error("Error fetching AI resumes:", error);
      if (error.response) {
        console.error("Response Data:", error.response.data);
        console.error("Status Code:", error.response.status);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAIResumes();
  }, [page]);
  const resumeSamples1 = [sampleResume1, sampleResume2, sampleResume3];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Dashboard - ResumeBeen | Manage and Build Your Professional Resumes
          Effortlessly
        </title>
        <link rel="canonical" href="https://resumebeen.com/dashboard" />
        <meta property="og:site_name" content="ResumeBeen" />
        <meta property="og:url" content="https://resumebeen.com/dashboard" />
        <meta property="og:locale" content="en_EN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@resumebeen" />
        <meta name="twitter:creator" content="@resumebeen" />
        <meta property="og:type" content="website" />
        <meta
          name="title"
          content="Dashboard - ResumeBeen | Manage and Build Your Professional Resumes Effortlessly"
        />
        <meta
          property="og:title"
          content="Dashboard - ResumeBeen | Manage and Build Your Professional Resumes Effortlessly"
        />
        <meta
          name="description"
          content="Welcome to your ResumeBeen Dashboard! Easily create, manage, and personalize your resumes and cover letters with AI-driven tools. Track your progress, access tailored templates, and build a standout resume in minutes."
        />
        <meta
          property="og:description"
          content="Welcome to your ResumeBeen Dashboard! Easily create, manage, and personalize your resumes and cover letters with AI-driven tools. Track your progress, access tailored templates, and build a standout resume in minutes."
        />
        <meta
          name="keywords"
          content="ResumeBeen dashboard, resume builder, AI resume tools, resume management, cover letter creator, job application tools, personalized resumes, professional resume templates, resume tracking, career advancement, resume analytics, resume customization, Matching Mode Analysis, resume progress tracking"
        />
        <meta
          property="og:keywords"
          content="ResumeBeen dashboard, resume builder, AI resume tools, resume management, cover letter creator, job application tools, personalized resumes, professional resume templates, resume tracking, career advancement, resume analytics, resume customization, Matching Mode Analysis, resume progress tracking"
        />
      </Helmet>
      <Navbar />
      <main className="container mx-auto p-0 d-grid">
        <div className="relative flex flex-col items-center justify-center min-h-screen px-4 sm:mx-4 mx-0 bg-center bg-cover pb-8">
          <img
            src={currentBgImage}
            alt="Background"
            className="absolute inset-0 object-cover object-top w-full h-full sm:object-fill "
            style={{ transform: "translateY(-11%)", opacity: "38%" }}
          />
          <div className="relative flex flex-col lg:flex-row mx-2 space-y-8 lg:space-y-0 lg:space-x-8 mt-14 lg:mt-16">
            <div className="flex flex-col space-y-8 lg:w-[58%] justify-center items-center text-left px-4 sm:px-0">
              <h1 className="font-archivo pl-0 sm:pl-28 ml-0 sm:ml-4 font-semibold text-4xl leading-tight text-left md:text-5xl md:leading-tight lg:text-[64px] lg:leading-[64px] text-transparent bg-clip-text bg-gradient-to-r from-[#003F3E] via-[#008583] to-[#FF7C37] ">
                Unlock your career potential with an &nbsp; <br />
                <span className="border-b-4 border-b-[#008583]">
                  AI-crafted
                </span>{" "}
                resume.
              </h1>
              <div className="text-left">
                <p className="text-[#535353] pl-0 sm:pl-28 ml-0 sm:ml-4 font-normal text-lg leading-6 md:text-xl md:leading-7 font-roboto">
                  Craft a standout resume effortlessly with our AI-driven
                  builder and customizable templates. Quick,
                </p>
                <p className="text-[#535353] pl-0 sm:pl-28 ml-0 sm:ml-4 font-normal text-lg leading-6 md:text-xl md:leading-7 font-roboto">
                  easy, and professional – get started for free and impress your
                  future employer in minutes!
                </p>
              </div>
              <div className="grid sm:flex sm:items-center sm:justify-center sm:space-x-3 gap-3 sm:gap-0">
                <div
                  className="flex w-[190px] md:w-[173px] h-[57px] rounded-[5px] p-[20px] gap-[20px] items-center justify-center py-4 px-2 md:px-4 text-base font-archivo font-normal leading-4 text-white bg-[#1F6463] cursor-pointer transition-colors duration-500 ease-in-out hover:bg-black"
                  onClick={() => navigate("/dashboard")}
                >
                  Get Started-It's Free
                </div>
                <div
                  className="flex w-[190px] md:w-[173px] h-[57px] rounded-[5px] p-[20px] gap-[20px] items-center justify-center py-4 px-2 md:px-4 text-base font-archivo font-normal leading-4 text-white bg-[#EE702E] cursor-pointer transition-colors duration-500 ease-in-out hover:bg-black"
                  onClick={() => navigate("/dashboard")}
                >
                  Resume Samples
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center lg:w-2/4">
              <Swiper
                effect="cube"
                grabCursor={true}
                loop={true} // Enables continuous loop
                autoplay={{
                  delay: 3000, // Delay of 5 minutes (300000ms)
                  disableOnInteraction: false,
                }}
                modules={[EffectCube, Autoplay]} // Register the Autoplay module
                className="h-[550px] w-[390px] md:h-[550px] md:w-[390px]" // Adjust width and height to match your rectangle
              >
                {resumeSamples1.map((sample, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={sample}
                      alt={`Sample Resume ${index + 1}`}
                      className="h-full w-full object-cover rounded-lg"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          <div className="mt-32 md:mx-2  ">
            <div className=" max-md:w-full">
              <div className="flex flex-col space-y-12 md:space-y-0 md:flex-row md:space-x-12">
                <div className="flex flex-col w-full lg:w-[589px] mt-4 space-y-4">
                  <h2 className="text-xl font-small leading-5 font-archivo text-[#1F6463] uppercase">
                    Your AI resume builder
                  </h2>
                  <h3 className="font-archivo font-normal text-2xl sm:text-4xl leading-8 sm:leading-10 text-[#1C1C1C]">
                    Power your resume by use of <br /> advanced{" "}
                    <span className="text-[#EE702E]">
                      Artificial Intelligence.
                    </span>
                  </h3>
                  <p className="text-sm sm:text-base font-roboto font-normal leading-6 text-[#535353]">
                    Are you having trouble finding the right words for your
                    resume?
                  </p>
                  <p className="text-sm sm:text-base font-roboto font-normal leading-6 text-[#535353]">
                    Use our AI-powered resume builder to{" "}
                    <b>automatically generate your entire resume</b>. The AI
                    Resume Writer can write professional sections for your{" "}
                    <b>resume summary</b>, <b>work experience</b>, and{" "}
                    <b>project details </b> with a consistent tone throughout
                    the document. Try it for free and get your AI-generated
                    Resume ready in minutes.
                  </p>
                  <div
                    className=" flex rounded-[5px] p-[20px] gap-[15px] w-[230.43px] h-[57px] bg-[#1F6463] cursor-pointer transition-colors duration-500 ease-in-out hover:bg-black"
                    onClick={() => navigate("/dashboard")}
                  >
                    <button className="absolute text-base  font-medium font-archivo leading-[17.41px] text-[#ffffff] ">
                      Try AI Resume Now
                    </button>
                    {/* <img
                    src={rightArrow1}
                    alt="right-arrow"
                    className="w-[28.43px] h-[16px] text-[#ffffff]"
                  /> */}
                  </div>
                </div>
                <div className="w-full lg:w-[532px] z-auto border border-[#D6D6D6] shadow-home-container-2-b rounded-[30px_30px_30px_30px] border-t border-transparent">
                  <div className="bg-[#D7D7D7] rounded-tl-xl rounded-tr-xl  w-full flex justify-between px-4 py-2">
                    <div className="flex items-center justify-between space-x-4">
                      {/* square - 1 */}
                      <div className="w-20 h-4 bg-[#F2F2F2] transform skew-x-12"></div>

                      {/* square - 2 */}
                      <div className="w-4 h-2 bg-[#F2F2F2] transform skew-x-12"></div>
                    </div>
                    <div className="flex items-center justify-between space-x-4">
                      {/* square -1 */}
                      <div className="bg-[#5BBD6A] w-3 h-3"></div>

                      {/* square - 2 */}
                      <div className="bg-[#EA625C] w-3 h-3"></div>
                    </div>
                  </div>
                  <div className="bg-[#E7E7E7] p-2 flex justify-between space-x-2">
                    <div className="flex items-center space-x-2">
                      <FaAngleLeft className="text-[#5A5A5A]" size="14" />
                      <FaArrowRightLong className="text-[#5A5A5A]" size="14" />
                      <IoIosRefresh className="text-[#5A5A5A]" size="14" />
                    </div>
                    <div className="bg-[#FFFFFF] h-4 flex items-center justify-between w-full">
                      <CiSearch className="text-[#5A5A5A]" size="14" />
                      <CiStar className="text-[#5A5A5A]" size="14" />
                    </div>
                    <div className="flex flex-col justify-between">
                      <p className="w-1 h-1 bg-[#5A5A5A] rounded-full"></p>
                      <p className="w-1 h-1 bg-[#5A5A5A] rounded-full"></p>
                      <p className="w-1 h-1 bg-[#5A5A5A] rounded-full"></p>
                    </div>
                  </div>
                  <div className="flex flex-col p-4 space-y-4">
                    <h2 className="text-[#1C1C1C] font-archivo font-semibold text-base leading-6">
                      Title
                    </h2>
                    <div className="w-full border p-2 border-[#D3D3D3] text-[#535353] font-archivo font-normal text-base text-start">
                      Python-ETL /TPRM
                    </div>
                    <h2 className="text-[#1C1C1C] font-archivo font-semibold text-base leading-6">
                      Description
                    </h2>
                    <div className="w-full h-auto border border-[#D3D3D3] text-[#535353] font-archivo font-normal text-base text-start">
                      <ul>
                        {points.map((point, i) => (
                          <li
                            key={i}
                            className={`text-[#535353] font-archivo font-normal text-sm p-1 transition-opacity duration-500 ${
                              visiblePoints.includes(point)
                                ? "opacity-100"
                                : "opacity-0"
                            }`}
                          >
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
            <div className="flex items-center justify-center mb-6 relative">
              <input
                type="text"
                placeholder="Search Resume by Title..."
                className="w-1/2 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setShowSuggestions(true);
                }}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              />
            </div>
            {showSuggestions && searchQuery && suggestions.length > 0 && (
              <div className="absolute bg-white border border-gray-300 rounded-lg shadow-md w-1/2 max-h-48 overflow-auto z-10">
                {suggestions.map((item, index) => (
                  <div
                    key={index}
                    className="p-2 hover:bg-gray-200 cursor-pointer"
                    onMouseDown={() => setSearchQuery(item.resumeTitle)}
                  >
                    {item.resumeTitle}
                  </div>
                ))}
              </div>
            )}
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAll ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {filteredResults.map((item, index) => {
                const formData = formatFormData(item);
                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{ boxShadow: "0px 8px 10px 0px #ccc" }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </motion.div>
       </div> */}

        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={It} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">
                  Information Technology
                </h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAll ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleResumes.map((item, index) => {
                const formData = formatFormData(item);
                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAll(!showAll)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                {/* Text with fixed width */}
                <span style={{ width: "fit-content" }}>
                  {showAll ? "See Less" : "Show More"}
                </span>

                {/* Arrow Icon */}
                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAll ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={accounts} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Account & Finance</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Accounting is essential for financial management in
                  businesses, ensuring accuracy in bookkeeping, tax compliance,
                  and financial reporting. It involves auditing, budgeting, and
                  financial analysis, playing a vital role in decision-making
                  and business growth.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllAccounts ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleAccountResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredAccountResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllAccounts(!showAllAccounts)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                {/* Text with fixed width */}
                <span style={{ width: "fit-content" }}>
                  {showAllAccounts ? "See Less" : "Show More"}
                </span>

                {/* Arrow Icon */}
                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllAccounts ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={education} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">
                  Teaching & education
                </h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleEducationResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredEducationResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllEducation(!showAllEducation)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllEducation ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllEducation ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={health} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Health & Nursing</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllHealth ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleHealthResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredHealthResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllHealth(!showAllHealth)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllHealth ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllHealth ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={quality} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Quality Assurance</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleQualityResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredQualityResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllQuality(!showAllQuality)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllQuality ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllQuality ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={sports} alt="IT Icon" className="w-16 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Sports & Trainer</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleSportsResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredSportsResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllSports(!showAllSports)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllSports ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllSports ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={engineer} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Engineers</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleEngineerResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredEngineerResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllEngineer(!showAllEngineer)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllEngineer ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllEngineer ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={sales} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">
                  Sales & Management
                </h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleSalesResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredSalesResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllSales(!showAllSales)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllSales ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllSales ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={real_estate} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Real Estate</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllEducation ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleEstateResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredEstateResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllEstate(!showAllEstate)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllEstate ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllEstate ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={chef} alt="IT Icon" className="w-22 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Food Services</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllFood ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleFoodResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredFoodResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllFood(!showAllFood)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllFood ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllFood ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={travel} alt="IT Icon" className="w-16 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">
                  Travel & Transportation
                </h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllTravel ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleTravelResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredTravelResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllTravel(!showAllTravel)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllTravel ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllTravel ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28">
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={salon} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Salon & Spa</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllSalon ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleSalonResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredSalonResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllSalon(!showAllSalon)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllSalon ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllSalon ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
        <div className="pt-32 md:px-6 pb-28" style={{ background: "#fafbfd" }}>
          <div className="d-grid md:mx-28">
            <div className="grid md:flex px-[42px] md:px-0 mb-10">
              <div className="md:w-5/12 flex items-start space-x-4">
                <img src={legal} alt="IT Icon" className="w-12 h-12" />
                <h1 className="text-[1.7rem] md:text-4xl">Legal</h1>
              </div>

              <div className="md:w-7/12">
                <p className="text-[18px]">
                  Information Technology (IT) plays a crucial role in modern
                  businesses and daily life, enabling seamless communication,
                  data management, and automation. It encompasses software
                  development, networking, cybersecurity, and cloud computing.
                  With rapid advancements, IT continues to drive innovation,
                  efficiency, and digital transformation across industries.
                </p>
              </div>
            </div>
            <motion.div
              className="d-flex flex-wrap justify-center"
              initial={{ height: "auto" }}
              animate={{ height: showAllLegal ? "auto" : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {visibleLegalResumes.map((item, index) => {
                const formData = formatFormData(item);

                return (
                  <div
                    key={index}
                    className="snap-start flex-none mx-2 rounded-2xl w-80 sm:w-80 sm:h-96 lg:w-[300px] lg:h-[400px] h-[400px] group relative"
                  >
                    {/* Apply border and shadow to the d-grid container */}
                    <div
                      className="d-grid h-[360px] border-2 border-gray-300 hover:border-gray-500 transition-all duration-300 rounded-2xl bg-white"
                      style={{
                        boxShadow: "0px 8px 10px 0px #ccc",
                      }}
                    >
                      <div
                        className="relative h-full  overflow-hidden text-center hover:cursor-pointer rounded-t-2xl
"
                        onClick={() => navigate("/dashboard")}
                      >
                        <div className="scale-[0.3] text-left origin-top-left w-[1000px]">
                          <div className="flex items-center justify-center origin-top-left scale-[1.0] sm:scale-[0.6] md:scale-[1] lg:scale-[1] min-h-screen">
                            {item.templateKey && (
                              <TemplateRenderer
                                templateKey={item.templateKey}
                                formData={formData}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="border-t border-gray-300 w-full"></div>

                      <div className="text-center text-lg font-semibold text-gray-700 p-2">
                        <div>{item.resumeTitle || "Untitled"}</div>
                      </div>
                    </div>

                    {/* Hover effect for "Use This Template" */}
                    <div
                      className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-green-700 text-white text-center py-2 px-4 w-1/2 
                              opacity-0 translate-y-4 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 ease-in-out rounded-md cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    >
                      Use This Template
                    </div>
                  </div>
                );
              })}
            </motion.div>
            {filteredLegalResumes.length > 4 && (
              <motion.div
                className="mt-4 flex items-center justify-center space-x-2 cursor-pointer text-blue-600 text-lg font-medium hover:text-blue-800 transition w-full px-[62px] md:px-[42px] !important"
                onClick={() => setShowAllLegal(!showAllLegal)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <span style={{ width: "fit-content" }}>
                  {showAllLegal ? "See Less" : "Show More"}
                </span>

                <motion.svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transition-transform duration-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  animate={{ rotate: showAllLegal ? 180 : 0 }}
                  style={{ width: "fit-content" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </motion.svg>
                <hr className="border-gray-300" style={{ width: "85%" }} />
              </motion.div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Resume_exmp;
